const Rank = ({ rankName, isCurrent, children }) => (
  <tr>{children}</tr>
);

export default Rank;
